import EventEmitter from 'events'
import { each } from 'lodash';

import { app } from '../utils/store'

// User Detect
import { DetectionManager } from '../utils/detect'

import { Navigation, Footer } from '../modules/Navigation'
import { BottomBar } from '../modules/BottomBar'

import Menu from '../modules/Menu'

export default class Page extends EventEmitter {
    constructor({
        element,
        elements,
        id,
        viewport,
        scroller
    }){
        super()
        
        this.root = document.body
        this.scroll = (scroller ? scroller : window)
        this.viewport = (viewport ? viewport : document.querySelector('[data-app-viewport]'))
        this.selector = element
        this.selectorChildren = { ...elements }
        
        this.id = id
    }

    create(){
        app.root = this.root
        app.scroll = this.scroll
        app.current = this.id
        app.viewport = this.viewport
        
        this.element = document.querySelector(this.selector)
        this.elements = {}

        this.scroll = {
            current: 0,
            target: 0,
            last: 0,
            limit: 0
        }

        each(this.selectorChildren, (entry, key) =>{
            if(entry instanceof window.HTMLElement || entry instanceof window.NodeList || Array.isArray(entry)){ // if is an element or an Array of the document
                this.elements[key] = entry
            } else {
                this.elements[key] = document.querySelectorAll(entry)

                if(this.elements[key].length === 0){
                    this.elements[key] = null
                } else if(this.elements[key].length === 1){
                    this.elements[key] = document.querySelector(entry)
                }
            }
        })

        app.html.scrollTop = 0
        app.root.scrollTop = 0

        this.createNavigation()
        this.addEventListeners()
    }

    // Create Navigation
    createNavigation = () => {
        this.statusbar = document.querySelector('[data-navigation-bottom-bar]')
        this.menu = document.querySelectorAll('[data-navigation-menu]')

        this.navigation = new Navigation({ init: app.bundle })
        this.footer = new Footer({ init: app.bundle })
        if (this.statusbar) { this.statusbar = new BottomBar({ init: app.bundle }) }

        if (this.menu) { each(this.menu, (entry, index) => new Menu({ element: entry })) }
    }

    /*
    ** Listeners
    */ 
    addEventListeners () { }

    removeEventListeners () { }

    /* Destroy */ 
    destroy = () => {
        this.removeEventListeners()
    }
}